export default __webpack_public_path__ + "static/media/henkel-logo.39643a9b.webp";